/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncPreviewEntry
 */
export interface SyncPreviewEntry {
    /**
     * 
     * @type {string}
     * @memberof SyncPreviewEntry
     */
    entryId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SyncPreviewEntry
     */
    created?: Date;
    /**
     * Feldname zu Wert-Mapping (nur Felder mit displayInPreview)
     * @type {{ [key: string]: string; }}
     * @memberof SyncPreviewEntry
     */
    columns?: { [key: string]: string; };
}

/**
 * Check if a given object implements the SyncPreviewEntry interface.
 */
export function instanceOfSyncPreviewEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SyncPreviewEntryFromJSON(json: any): SyncPreviewEntry {
    return SyncPreviewEntryFromJSONTyped(json, false);
}

export function SyncPreviewEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncPreviewEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entryId': !exists(json, 'entryId') ? undefined : json['entryId'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'columns': !exists(json, 'columns') ? undefined : json['columns'],
    };
}

export function SyncPreviewEntryToJSON(value?: SyncPreviewEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entryId': value.entryId,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'columns': value.columns,
    };
}

